import React from 'react';
import { CircularProgress, Box } from '@mui/material';
import { Navigate } from 'react-router-dom';
import usePurchaseWorkflow from '../../../hooks/usePurchaseWorkflow';
import { PURCHASE_STAGES } from '../../../utils/purchaseWorkflow';

const LIST_ROUTES = { PR: '/PurchaseRequest', PO: '/PurchaseOrder', PD: '/GRN', PI: '/PurchaseInvoice' };

export default function PurchaseWorkflowGuard({ stage, children }) {
  const { startStage, loading } = usePurchaseWorkflow();
  if (loading) return <Box sx={{ minHeight: '60vh', display: 'grid', placeItems: 'center' }}><CircularProgress /></Box>;
  if (PURCHASE_STAGES.indexOf(stage) < PURCHASE_STAGES.indexOf(startStage)) {
    return <Navigate to={LIST_ROUTES[startStage]} replace />;
  }
  return children;
}
